<template>
    <div class="w-[360px] flex-none rounded border">
        <div
            class="flex h-16 w-full max-w-[360px] items-center justify-center rounded-lg rounded-b-none bg-[url(/assets/art/performance_summary_header.png)] bg-[length:100%_100%] bg-bottom bg-no-repeat p-4 pt-2 text-center text-center font-semibold text-white"
        >
            <div class="">PERFORMANCE SUMMARY</div>
        </div>
        <div class="p-4 text-[15px]">
            <div class="mb-4 flex items-center justify-center gap-2">
                <div class="text-[13px] font-semibold">Summary</div>
                <div class="h-[1px] flex-grow border-b border-gray-250">
                    <hr/>
                </div>
            </div>

            <div class="mb-8 flex flex-col gap-4">
                <div class="flex items-center gap-2">
                    <div class="">
                        <svg
                            width="22"
                            height="20"
                            viewBox="0 0 22 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M1.25 0.25C1.05109 0.25 0.860322 0.329018 0.71967 0.46967C0.579018 0.610322 0.5 0.801088 0.5 1C0.5 1.19891 0.579018 1.38968 0.71967 1.53033C0.860322 1.67098 1.05109 1.75 1.25 1.75H2V12.25C2 13.0456 2.31607 13.8087 2.87868 14.3713C3.44129 14.9339 4.20435 15.25 5 15.25H6.21L5.038 18.763C4.97514 18.9518 4.98988 19.1579 5.07896 19.3359C5.16804 19.5138 5.32417 19.6491 5.513 19.712C5.70183 19.7749 5.9079 19.7601 6.08588 19.671C6.26385 19.582 6.39914 19.4258 6.462 19.237L6.791 18.25H15.209L15.539 19.237C15.6073 19.4186 15.7433 19.5666 15.9184 19.6501C16.0935 19.7335 16.2941 19.7459 16.4782 19.6845C16.6622 19.6232 16.8153 19.4929 16.9053 19.3211C16.9954 19.1493 17.0153 18.9492 16.961 18.763L15.791 15.25H17C17.7956 15.25 18.5587 14.9339 19.1213 14.3713C19.6839 13.8087 20 13.0456 20 12.25V1.75H20.75C20.9489 1.75 21.1397 1.67098 21.2803 1.53033C21.421 1.38968 21.5 1.19891 21.5 1C21.5 0.801088 21.421 0.610322 21.2803 0.46967C21.1397 0.329018 20.9489 0.25 20.75 0.25H1.25ZM7.79 15.25H14.21L14.71 16.75H7.29L7.79 15.25ZM15.875 6.255C15.961 6.20611 16.0364 6.1407 16.097 6.06253C16.1577 5.98436 16.2022 5.89497 16.2281 5.79952C16.254 5.70406 16.2608 5.60443 16.2481 5.50634C16.2353 5.40826 16.2033 5.31366 16.1538 5.228C16.1044 5.14235 16.0385 5.06732 15.9599 5.00724C15.8813 4.94715 15.7916 4.90321 15.696 4.87793C15.6004 4.85264 15.5007 4.84653 15.4027 4.85993C15.3047 4.87333 15.2103 4.90598 15.125 4.956C13.7615 5.74523 12.5554 6.7792 11.567 8.006L10.03 6.47C9.88937 6.32955 9.69875 6.25066 9.5 6.25066C9.30125 6.25066 9.11063 6.32955 8.97 6.47L5.97 9.47C5.89631 9.53866 5.83721 9.62146 5.79622 9.71346C5.75523 9.80546 5.73319 9.90477 5.73141 10.0055C5.72963 10.1062 5.74816 10.2062 5.78588 10.2996C5.8236 10.393 5.87974 10.4778 5.95096 10.549C6.02218 10.6203 6.10701 10.6764 6.2004 10.7141C6.29379 10.7518 6.39382 10.7704 6.49452 10.7686C6.59523 10.7668 6.69454 10.7448 6.78654 10.7038C6.87854 10.6628 6.96134 10.6037 7.03 10.53L9.5 8.06L11.117 9.678C11.1946 9.75558 11.2882 9.81519 11.3913 9.85264C11.4945 9.89008 11.6046 9.90445 11.7138 9.89472C11.8231 9.885 11.9289 9.85142 12.0238 9.79635C12.1187 9.74128 12.2003 9.66606 12.263 9.576C13.2095 8.21806 14.4425 7.0844 15.875 6.255Z"
                                fill="#4098DD"
                            />
                        </svg>
                    </div>
                    <span class="font-semibold">{{
                            student.student_total_questions_answered ?? 0
                        }}</span>
                    questions answered
                </div>
                <div class="flex items-center gap-2">
                    <div class="">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10 0.25C4.615 0.25 0.25 4.615 0.25 10C0.25 15.385 4.615 19.75 10 19.75C15.385 19.75 19.75 15.385 19.75 10C19.75 4.615 15.385 0.25 10 0.25ZM10.75 4C10.75 3.80109 10.671 3.61032 10.5303 3.46967C10.3897 3.32902 10.1989 3.25 10 3.25C9.80109 3.25 9.61032 3.32902 9.46967 3.46967C9.32902 3.61032 9.25 3.80109 9.25 4V10C9.25 10.414 9.586 10.75 10 10.75H14.5C14.6989 10.75 14.8897 10.671 15.0303 10.5303C15.171 10.3897 15.25 10.1989 15.25 10C15.25 9.80109 15.171 9.61032 15.0303 9.46967C14.8897 9.32902 14.6989 9.25 14.5 9.25H10.75V4Z"
                                fill="#4098DD"
                            />
                        </svg>
                    </div>
                    <span class="font-semibold">{{
                            student.time_spent_studying_readable
                        }}</span>
                    total study time
                </div>
                <div
                    class="flex items-center gap-2"
                    v-if="
                        shouldShowGoals &&
                        $page.props.currentClassroom &&
                        $page.props.currentClassroom.goals
                    "
                >
                    <div class="">
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M3.30505 1.185V1.9C2.44255 2.02333 1.58921 2.175 0.745879 2.3525C0.588053 2.38594 0.449271 2.47912 0.358567 2.61253C0.267862 2.74595 0.232262 2.90927 0.259212 3.06833C0.469684 4.30502 1.08734 5.43593 2.01406 6.28143C2.94079 7.12693 4.12346 7.63854 5.37421 7.735C6.04008 8.2792 6.82218 8.66297 7.66005 8.85667C7.58042 9.80252 7.26122 10.7125 6.73255 11.5008H6.11671C5.25338 11.5008 4.55421 12.2008 4.55421 13.0633V15.2508H3.92921C3.43193 15.2508 2.95502 15.4484 2.60339 15.8C2.25176 16.1516 2.05421 16.6286 2.05421 17.1258C2.05421 17.4708 2.33421 17.7508 2.67921 17.7508H15.1792C15.345 17.7508 15.5039 17.685 15.6212 17.5678C15.7384 17.4506 15.8042 17.2916 15.8042 17.1258C15.8042 16.6286 15.6067 16.1516 15.255 15.8C14.9034 15.4484 14.4265 15.2508 13.9292 15.2508H13.3042V13.0633C13.3042 12.2 12.6042 11.5008 11.7417 11.5008H11.1259C10.5975 10.7124 10.2786 9.80245 10.1992 8.85667C11.0371 8.66273 11.8193 8.27866 12.485 7.73417C13.7359 7.63788 14.9188 7.12635 15.8457 6.28084C16.7726 5.43532 17.3904 4.30432 17.6009 3.0675C17.6276 2.90845 17.5917 2.74523 17.5009 2.61198C17.41 2.47873 17.2712 2.38576 17.1134 2.3525C16.2658 2.17346 15.4126 2.02255 14.555 1.9V1.18417C14.555 1.03173 14.4992 0.884579 14.3982 0.770394C14.2972 0.656209 14.158 0.582867 14.0067 0.564168C12.3223 0.354487 10.6266 0.249563 8.92921 0.250001C7.21004 0.250001 5.51588 0.356668 3.85171 0.564168C3.70058 0.583054 3.56154 0.656478 3.46073 0.770644C3.35991 0.884809 3.30425 1.03186 3.30421 1.18417L3.30505 1.185ZM3.30505 3.37583C3.30505 4.3725 3.56505 5.30917 4.01921 6.12083C3.45593 5.86824 2.95227 5.49965 2.54116 5.03914C2.13004 4.57862 1.82071 4.03655 1.63338 3.44833C2.18841 3.34063 2.74577 3.24533 3.30505 3.1625V3.37583ZM14.555 3.37583V3.1625C15.1167 3.24583 15.6742 3.34083 16.2267 3.44833C16.0394 4.03657 15.7301 4.57867 15.319 5.03919C14.9079 5.49971 14.4042 5.86829 13.8409 6.12083C14.3106 5.28228 14.5565 4.33696 14.555 3.37583Z"
                                fill="#4098DD"
                            />
                        </svg>
                    </div>
                    <span class="font-semibold"
                    >{{ classroomGoalsComplete }} of
                        {{ classroomGoalsTotal }}</span
                    >
                    assigned goals completed
                </div>
            </div>
            <div class="" v-if="$page.props.currentClassroom">
                <div
                    class="mb-4 flex items-center justify-center gap-2"
                    v-if="shouldShowGoals"
                >
                    <div class="text-[13px] font-semibold">Classroom Goals</div>
                    <div class="h-[1px] flex-grow border-b border-gray-250">
                        <hr/>
                    </div>
                </div>

                <div class="mb-8 flex flex-col gap-4 whitespace-nowrap">
                    <template v-for="(goal, index) in student.classroom_goals">
                        <div
                            class="flex items-center gap-2"
                            v-if="goal.enabled"
                        >
                            <div class="">
                                <svg
                                    v-if="goal.completed"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M0.25 10C0.25 4.615 4.615 0.25 10 0.25C15.385 0.25 19.75 4.615 19.75 10C19.75 15.385 15.385 19.75 10 19.75C4.615 19.75 0.25 15.385 0.25 10ZM13.61 8.186C13.67 8.10605 13.7134 8.01492 13.7377 7.91795C13.762 7.82098 13.7666 7.72014 13.7514 7.62135C13.7361 7.52257 13.7012 7.42782 13.6489 7.3427C13.5965 7.25757 13.5276 7.18378 13.4463 7.12565C13.3649 7.06753 13.2728 7.02624 13.1753 7.00423C13.0778 6.98221 12.9769 6.97991 12.8785 6.99746C12.7801 7.01501 12.6862 7.05205 12.6023 7.10641C12.5184 7.16077 12.4462 7.23135 12.39 7.314L9.154 11.844L7.53 10.22C7.38783 10.0875 7.19978 10.0154 7.00548 10.0188C6.81118 10.0223 6.62579 10.101 6.48838 10.2384C6.35097 10.3758 6.27225 10.5612 6.26882 10.7555C6.2654 10.9498 6.33752 11.1378 6.47 11.28L8.72 13.53C8.79699 13.6069 8.8898 13.6662 8.99199 13.7036C9.09418 13.7411 9.20329 13.7559 9.31176 13.7469C9.42023 13.738 9.52546 13.7055 9.62013 13.6519C9.7148 13.5982 9.79665 13.5245 9.86 13.436L13.61 8.186Z"
                                        fill="#089B6D"
                                    />
                                </svg>
                                <svg
                                    v-else
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M10 0.25C4.615 0.25 0.25 4.615 0.25 10C0.25 15.385 4.615 19.75 10 19.75C15.385 19.75 19.75 15.385 19.75 10C19.75 4.615 15.385 0.25 10 0.25ZM8.28 7.22C8.21134 7.14631 8.12854 7.08721 8.03654 7.04622C7.94454 7.00523 7.84522 6.98318 7.74452 6.98141C7.64382 6.97963 7.54379 6.99816 7.4504 7.03588C7.35701 7.0736 7.27218 7.12974 7.20096 7.20096C7.12974 7.27218 7.0736 7.35701 7.03588 7.4504C6.99816 7.54379 6.97963 7.64382 6.98141 7.74452C6.98318 7.84522 7.00523 7.94454 7.04622 8.03654C7.08721 8.12854 7.14631 8.21134 7.22 8.28L8.94 10L7.22 11.72C7.14631 11.7887 7.08721 11.8715 7.04622 11.9635C7.00523 12.0555 6.98318 12.1548 6.98141 12.2555C6.97963 12.3562 6.99816 12.4562 7.03588 12.5496C7.0736 12.643 7.12974 12.7278 7.20096 12.799C7.27218 12.8703 7.35701 12.9264 7.4504 12.9641C7.54379 13.0018 7.64382 13.0204 7.74452 13.0186C7.84522 13.0168 7.94454 12.9948 8.03654 12.9538C8.12854 12.9128 8.21134 12.8537 8.28 12.78L10 11.06L11.72 12.78C11.7887 12.8537 11.8715 12.9128 11.9635 12.9538C12.0555 12.9948 12.1548 13.0168 12.2555 13.0186C12.3562 13.0204 12.4562 13.0018 12.5496 12.9641C12.643 12.9264 12.7278 12.8703 12.799 12.799C12.8703 12.7278 12.9264 12.643 12.9641 12.5496C13.0018 12.4562 13.0204 12.3562 13.0186 12.2555C13.0168 12.1548 12.9948 12.0555 12.9538 11.9635C12.9128 11.8715 12.8537 11.7887 12.78 11.72L11.06 10L12.78 8.28C12.8537 8.21134 12.9128 8.12854 12.9538 8.03654C12.9948 7.94454 13.0168 7.84522 13.0186 7.74452C13.0204 7.64382 13.0018 7.54379 12.9641 7.4504C12.9264 7.35701 12.8703 7.27218 12.799 7.20096C12.7278 7.12974 12.643 7.0736 12.5496 7.03588C12.4562 6.99816 12.3562 6.97963 12.2555 6.98141C12.1548 6.98318 12.0555 7.00523 11.9635 7.04622C11.8715 7.08721 11.7887 7.14631 11.72 7.22L10 8.94L8.28 7.22Z"
                                        fill="#CA3A31"
                                    />
                                </svg>
                            </div>
                            <div class="">
                                <span v-if="goal.type === 'study_hours'">
                                    Study for {{ goal.target }} hours</span
                                >
                                <span v-if="goal.type === 'answer_questions'"
                                >Answer {{ goal.target }} questions</span
                                >
                            </div>
                            <div class="text-[11px]">•</div>
                            <div class="text-gray-650">
                                from
                                <span
                                    v-if="
                                        dayjs(goal.startingFrom) ===
                                        dayjs(
                                            $page.props.currentClassroom
                                                .created_at
                                        )
                                    "
                                >"all time"
                                </span>
                                <span v-else>{{
                                        dayjs(goal.startingFrom).format(
                                            $page.props.date_formats.short
                                        )
                                    }}</span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NewModal from "@/Components/NewModal";

export default {
    name: "GroupStudentPerformanceSummary",
    components: {NewModal},
    props: {
        student: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            showGoalsLimit: 3,
        };
    },
    computed: {
        shouldShowGoals() {
            let vm = this;
            let enabledGoals = [];

            if (!this.$page.props.currentClassroom) {
                return false;
            }

            enabledGoals = _.filter(
                this.$page.props.currentClassroom.goals,
                function (goal) {
                    return goal.enabled;
                }
            );

            if (enabledGoals.length) {
                return true;
            } else {
                return false;
            }
        },
        classroomGoalsComplete() {
            let completedGoals = _.filter(
                this.student.classroom_goals,
                function (goal) {
                    return goal.enabled && goal.completed;
                }
            );


            return completedGoals.length;
        },
        classroomGoalsTotal() {
            let enabledGoals = _.filter(
                this.student.classroom_goals,
                function (goal) {
                    return goal.enabled;
                }
            );

            return enabledGoals.length;
        },
    },
};
</script>
